import { Link } from 'react-router-dom'
import { Button } from '@shared-ui/button'
import errorGraphic from '@/assets/error-graphic.jpg'

/**
 * Full-page fallback when a route-level ErrorBoundary catches a render error.
 */
export function GenericErrorPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="max-w-md w-full">
        <div className="text-center space-y-6">
          <div className="space-y-2">
            <img
              src={errorGraphic}
              alt=""
              className="mx-auto max-h-48 w-auto max-w-full object-contain"
            />
            <div className="h-0.5 w-16 bg-slate-200 mx-auto" />
          </div>

          <div className="space-y-3">
            <h2 className="text-2xl font-medium text-slate-800">
              Something went wrong
            </h2>
            <p className="text-slate-600 leading-relaxed">
              An unexpected error occurred while loading this screen. Try
              refreshing the page, or go back to the dashboard.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
            <Button type="button" onClick={() => window.location.reload()}>
              Refresh page
            </Button>
            <Button variant="secondary" asChild>
              <Link to="/Dashboard">Go to dashboard</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
